import axios from 'axios';

const getListarComercios = async function(url, token) {
    try {
        return await axios({
            url,
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token
            },
        })
    } catch (e) {
        return e.response
    }
}
export {
    getListarComercios
}